import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import BaseLink from '~/components/base/BaseLink';
import Icon from '~/components/base/Icon';

import { iconColors } from '~/theme';

const SocialList = styled.ul`
    display: flex;
    gap: 20px;
`;

const IconLink = styled(BaseLink)`
    &:hover,
    &:focus {
        svg * {
            color: ${iconColors.yellow};
        }
    }
`;

const SocialLinks = ({
    socialAccounts,
    color = 'white',
    size = 18,
    ariaLabelledBy = '',
    role = ''
}) => {
    return socialAccounts?.length ? (
        <SocialList {...{ role }} aria-labelledby={ariaLabelledBy}>
            {socialAccounts.map(({ linkUrl, iconClass }) => (
                <li key={linkUrl}>
                    <IconLink to={linkUrl}>
                        <Icon icon={iconClass} {...{ color, size }} />
                    </IconLink>
                </li>
            ))}
        </SocialList>
    ) : null;
};

SocialLinks.propTypes = {
    socialAccounts: PropTypes.arrayOf(
        PropTypes.shape({
            linkUrl: PropTypes.string.isRequired,
            iconClass: PropTypes.string.isRequired
        })
    ).isRequired,
    color: PropTypes.oneOf(Object.keys(iconColors)),
    size: PropTypes.number,
    ariaLabelledBy: PropTypes.string,
    role: PropTypes.string
};

export default SocialLinks;
